import * as React from "react";
import * as ReactDOM from "react-dom";

import { CustomScrollbar } from "../../../components";

import "./CategoryList.css";

export interface CategoryListProps {
  categoryItems: JSX.Element | JSX.Element[];
}

interface CategoryListState {
  height: number;
}

class CategoryList extends React.Component {
  props: CategoryListProps;
  state: CategoryListState;

  constructor(props: CategoryListProps) {
    super(props);

    this.state = {
      height: 0,
    };
  }

  componentDidMount() {
    const rect = ReactDOM.findDOMNode(this).getBoundingClientRect();
    const height = window.innerHeight - rect.top - 76; // footer height = 76
    this.setState({ height });
  }

  render() {
    return (
      <div className="category-list">
        <div className="row">
          <CustomScrollbar maxHeight={this.state.height}>
            {this.props.categoryItems}
          </CustomScrollbar>
        </div>
      </div>
    );
  }
}

export default CategoryList;



// WEBPACK FOOTER //
// ./src/routes/Step1/components/CategoryList.tsx